"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = require("lodash");
var _ui = require("@unite-us/ui");
function stringifyAddress() {
  var address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getValue = function getValue(fieldName) {
    var field = address[fieldName] || {};
    return (0, _ui.getPreferredProp)(field, 'value') || '';
  };
  var parts = [getValue('line_1'), getValue('city'), "".concat(getValue('state'), " ").concat(getValue('postal_code')).trim()];
  return (0, _lodash.join)((0, _lodash.compact)(parts), ', ');
}
var _default = exports["default"] = stringifyAddress;